export const FeaturesEnum = {
  /**
   * Controls the new feed. Has feature values. Backend-synchronized.
   */
  NewFeed: 'de.fhg.iese.dd.dorffunk.new-post-tab',

  /**
   * Controls the gossip feed. Has feature values. Backend-synchronized.
   */
  Gossip: 'de.fhg.iese.dd.dorffunk.gossip',

  /**
   * Controls the news feed. Has feature values. Backend-synchronized.
   */
  NewsItem: 'de.fhg.iese.dd.dorffunk.newsitem',

  /**
   * Controls the emergency organization's feed. Backend-synchronized.
   */
  Emergency: 'de.fhg.iese.dd.dorffunk.organizations.emergency-aid',

  /**
   * Controls the civil protection organization's feed. Backend-synchronized.
   */
  CivilProtection: 'de.fhg.iese.dd.dorffunk.organizations.civil-protection',

  /**
   * Controls the suggestion feed. Has feature values. Backend-synchronized.
   */
  Suggestion: 'de.fhg.iese.dd.dorffunk.suggestion',

  /**
   * Controls the suggestion creation. Backend-synchronized.
   */
  SuggestionCreation: 'de.fhg.iese.dd.dorffunk.suggestion.creation',

  /**
   * Controls the offer feed. Has feature values. Backend-synchronized.
   */
  Offer: 'de.fhg.iese.dd.dorffunk.offer',

  /**
   * Controls the seeking feed. Has feature values. Backend-synchronized.
   */
  Seeking: 'de.fhg.iese.dd.dorffunk.seeking',

  /**
   * Controls the happening feed. Has feature values. Backend-synchronized.
   */
  Happening: 'de.fhg.iese.dd.dorffunk.happening',

  /**
   * Controls the happening creation. Has feature values. Backend-synchronized.
   */
  HappeningCreation: 'de.fhg.iese.dd.dorffunk.happening.creation',

  /**
   * Controls the happening participation feed. Backend-synchronized.
   */
  HappeningParticipation: 'de.fhg.iese.dd.dorffunk.happening.participation',

  /**
   * Controls the availability of the happening participants list. Backend-synchronized.
   */
  HappeningParticipants: 'de.fhg.iese.dd.dorffunk.happening.list-participants',

  /**
   * Controls the special post feed. Has feature values. Backend-synchronized.
   */
  SpecialPost: 'de.fhg.iese.dd.dorffunk.specialpost',

  /**
   * Controls the attachments. Has feature values. Backend-synchronized.
   */
  Attachments: 'de.fhg.iese.dd.dorffunk.attachment',

  /**
   * Controls the restriction of content based on verification status. Has feature values. Backend-synchronized.
   */
  ContentRestriction: 'de.fhg.iese.dd.dorffunk.content.creation-restriction',

  /**
   * Controls the conveniences. Backend-synchronized.
   */
  Conveniences: 'de.fhg.iese.dd.dorffunk.convenience',

  /**
   * Controls the selection of geo areas. Has feature values. Backend-synchronized.
   */
  GeoAreaSelection: 'de.fhg.iese.dd.dorffunk.geoarea-selection',

  /**
   * Controls the groups. Backend-synchronized.
   */
  Groups: 'de.fhg.iese.dd.dorffunk.group',

  /**
   * Controls the creation of groups. Backend-synchronized.
   */
  GroupCreation: 'de.fhg.iese.dd.dorffunk.group.creation',

  /**
   * Controls the availability of private groups. Backend-synchronized.
   */
  GroupsPrivate:
    'de.fhg.iese.dd.dorffunk.group.accessibility.approval-required',

  /**
   * Controls the group member lists. Backend-synchronized.
   */
  GroupMembers: 'de.fhg.iese.dd.dorffunk.group.list-members',

  /**
   * Controls the volunteerings. Backend-synchronized.
   */
  Volunteering: 'de.fhg.iese.dd.dorffunk.volunteering',

  /**
   * Controls the Entertainment. Backend-synchronized.
   */
  Entertainment: 'de.fhg.iese.dd.dorffunk.organizations.entertainment',

  /**
   * Controls the polls. Backend-synchronized.
   */
  Poll: 'de.fhg.iese.dd.dorffunk.poll',
  /**
   * Controls if a dark mode is selectable
   */
  DarkMode: 'de.fhg.iese.dd.dorffunk.dark-mode',

  /**
   * Controls if the developer menu is accessible
   */
  DevMode: 'de.fhg.iese.dd.dorffunk.dev-mode',

  ExampleLocalFeature: 'feature.local.example'
} as const;

export type FeaturesEnum = (typeof FeaturesEnum)[keyof typeof FeaturesEnum];
